export default "/images/custom_development/web_2_design_and_development__top_image.png";